import {
    LogicStepDefinition,
    SystemEntity,
} from '@wdx/shared/utils';

export const WorkflowNodeType = {
    LogicStep: 'logic-step',
    Query: 'query',
} as const;
export type WorkflowNodeType =
    (typeof WorkflowNodeType)[keyof typeof WorkflowNodeType];

export type WorkflowNodeChildren = Record<string, WorkflowNode[]>;

export interface WorkflowNode extends LogicStepDefinition {
    nodeType: WorkflowNodeType;
    payload: WorkflowNodePayload;
    children?: WorkflowNodeChildren;
    childLogicCodesOrder?: string[];
    isValid: boolean;
    isRemovable: boolean;
    logicCode?: string;
    targetEntityType?: SystemEntity;
}

export interface WorkflowNodePayload {
    Code: string;
    Id: string;
    [key: string]: any;
}

export type NodeAddedEvent = {
    parentId: string;
    logicCode?: string;
    isNewLogic?: boolean;
};

export type ParamsChangedEvent = {
    formValues: Record<string, any>;
    isValid: boolean;
};

export interface QueryNodePolicy {
    required: boolean;
    allowed: boolean;
    removable: boolean;
}

export type WorkflowLogicStepDef = LogicStepDefinition & {
    isDisabled?: boolean;
};
